import {APICore} from './apiCore';
import {useEffect, useState} from 'react';
import {Group} from '../../model/Group';

const api = new APICore();

export const GetGroups = () => {
    const [data, setData] = useState<Group[]>([]);
    const [next, setNext] = useState(true);
    const [page, setPage] = useState(1);

    const fetchData = async () => {
        const lot: Group[] = [];

        try {
            const {data: response} = await api.get('/api/groups', {page: page});

            response.map((group: Group) => {
                if (data.some((g: Group) => g.id === group.id)) return group;
                setData((data) => [
                        ...data,
                        new Group(
                            group.id,
                            group.name,
                            group.superGroup,
                            group.pool,
                            group.contactClientType,
                        ),
                    ],
                );
                lot.push(group);
                return group;
            });
        } catch (e) {
            console.log(e);
        }

        return lot;
    };
    useEffect(() => {
        if (next) {
            fetchData()
                .then((r) => {
                    if (r.length < 1) {
                        setNext(false);
                    } else {
                        setPage(page + 1);
                    }
                });
        }
        // eslint-disable-next-line
    }, [page]);

    return data;
};
